export default "__VITE_ASSET__DTlfJuOE__"